export function formatINR(amount) {
  const n = Number(amount);
  if (Number.isNaN(n)) return '₹0';
  return `₹${n.toLocaleString('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;
}

export function statusBadgeClass(status) {
  const key = String(status || '')
    .toLowerCase()
    .replace(/\s+/g, '_');
  if (key === 'paid' || key === 'completed' || key === 'resolved' || key === 'closed') {
    return 'pg-badge-paid';
  }
  if (key === 'open' || key === 'in_progress') return 'pg-badge-open';
  if (key === 'sent' || key === 'overdue' || key === 'partially_paid' || key === 'pending') {
    return 'pg-badge-sent';
  }
  return 'pg-badge-closed';
}

export function prettyStatus(status) {
  if (!status) return 'N/A';
  return String(status)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
